import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useAuth } from '../../auth/AuthContext.js';
import { useAnalyticsConfig } from '../../config/ConfigContext.js';
import { initAnalytics, identifyUser, resetAnalytics, trackPageView } from './index.js';

// Drives the analytics chokepoint from React context: initializes once the
// runtime config resolves, (re)identifies on auth change, and tracks a page
// view per navigation. Mounted inside the Router (so useLocation works) under
// ConfigProvider + AuthProvider (see main.tsx). Renders nothing.
//
// Impersonation-aware: an active employee-impersonation session is passed to
// identifyUser, which suppresses all capture for it (ADR-008 + ADR-014).
export default function AnalyticsBootstrap(): null {
  const { clarityProjectId, appInsightsConnectionString } = useAnalyticsConfig();
  const auth = useAuth();
  const location = useLocation();
  const [ready, setReady] = useState(false);

  const user = auth.status === 'signed_in' ? auth.user : null;
  const impersonating = auth.status === 'signed_in' && auth.impersonation !== null;

  useEffect(() => {
    if (clarityProjectId || appInsightsConnectionString) {
      initAnalytics({ clarityProjectId, appInsightsConnectionString });
      setReady(true);
    }
  }, [clarityProjectId, appInsightsConnectionString]);

  useEffect(() => {
    if (!ready) return;
    if (user) identifyUser(user, { impersonating });
    else resetAnalytics();
  }, [ready, user, impersonating]);

  useEffect(() => {
    if (!ready) return;
    trackPageView(location.pathname);
  }, [ready, location.pathname]);

  return null;
}
